module.exports = __webpack_public_path__ + "img/btn2.1a7b701c.png";